import getEndpoint from '../utils/getEndpoint'

export default function fetchLimitedStock(r_id) {
  if (!r_id) return Promise.resolve({})
  return fetch(`${getEndpoint('limited-stock')}?r_id=${encodeURIComponent(r_id)}`)
    .then(r => r.json())
    .then(d => (d && d.text) || {})
    .catch(e => {
      console.log('fetchLimitedStock error', e)
      return {}
    })
}
